import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/system';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import DeleteAddressbookDialog from '#component/addressbook/dashboard/delete-addressbook-dialog';
import { deleteAddressbook } from '#action/addressbook/addressbook';
import { fetchContacts } from '#action/addressbook/addressbook-contacts-paginated';
import { getContrastColor } from '#component/theme';

const StyledAddIcon = styled(AddIcon)(() => ({
  color: getContrastColor(),
  marginRight: 5
}));

const StyledEditIcon = styled(EditIcon)(() => ({
  color: getContrastColor(),
  marginRight: 5
}));

const StyledDeleteIcon = styled(DeleteRoundedIcon)(({ theme }) => ({
  color: 'rgba(0, 0, 0, 0.54)',
  marginRight: theme.spacing()
}));

/**
 * Renders address book actions and delete dialog.
 * @returns {React.FC}
 */

const AddressbookActions = props => {
  const { anchorEl, setAnchorEl = () => null, addressbook } = props;
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeleteClick = () => {
    setOpen(true);
  };

  const handleDeleteClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const handleDelete = async () => {
    const result = await dispatch(deleteAddressbook(addressbook?.id));
    if (result?.success) {
      handleDeleteClose();
      dispatch(fetchContacts({ refetchAddressbooks: true }));
    }
  };

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          component={Link}
          to={`/addressbook/contact/create${addressbook.id ? `?addressbookId=${addressbook.id}` : ''}`}
        >
          <StyledAddIcon />
          Add contact
        </MenuItem>
        <MenuItem
          component={Link}
          to={`/addressbook/edit/${addressbook?.id}`}
        >
          <StyledEditIcon />
          Edit
        </MenuItem>
        <MenuItem onClick={handleDeleteClick}>
          <StyledDeleteIcon />
          Delete
        </MenuItem>
      </Menu>
      <DeleteAddressbookDialog
        open={open}
        dialogTitle={`Do you want to delete the "${addressbook?.label ?? ''}"?`}
        entityTitle={addressbook?.label ?? ''}
        dialogContentText="Type the address book label to confirm"
        textFieldLabel="Label"
        onClose={handleDeleteClose}
        onDelete={handleDelete}
      />
    </>
  );
};

export default AddressbookActions;
